import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const LogoFullDark: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="565"
      height="173"
      viewBox="0 0 565 173"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1_67)">
        <path
          d="M0.984131 52.0395L86.0946 0.569092V23.5003L4.33697 72.9156L0.984131 52.0395Z"
          fill="#FF1A5B"
        />
        <path
          d="M171.005 52.1788L86.0936 0.569092V23.5003L167.3 73.6122L171.005 52.1788Z"
          fill="#FF1A5B"
        />
        <path
          d="M164.733 92.2009L161.931 109.64L86.0936 172.28V154.249L164.733 92.2009Z"
          fill="white"
        />
        <path
          d="M7.44348 92.2009L86.0945 154.249V172.28L10.3157 110.07L7.44348 92.2009Z"
          fill="white"
        />
        <path
          d="M164.733 92.2012L86.0936 45.3635V62.7796L161.931 109.641L164.733 92.2012Z"
          fill="white"
        />
        <path
          d="M86.0936 112.938L171.005 52.1794L167.3 73.6129L86.0936 134.546V112.938Z"
          fill="#FF1A5B"
        />
        <path
          d="M0.983765 52.0393L86.0943 112.938V134.545L4.3366 72.9154L0.983765 52.0393Z"
          fill="#FF1A5B"
        />
        <path
          d="M7.44348 92.2012L86.0945 45.3635V62.7796L10.3157 110.07L7.44348 92.2012Z"
          fill="white"
        />
        <path
          d="M86.3878 23.6861L86.0947 23.5003L85.8016 23.6861V0.743246L86.0947 0.569092L86.3878 0.743246V23.6861Z"
          fill="#383942"
        />
        <path
          d="M85.8016 112.729L86.0947 112.938L86.3878 112.729V134.313L86.0947 134.545L85.8016 134.336V112.729Z"
          fill="#383942"
        />
        <path
          d="M85.8016 154.017L86.0947 154.249L86.3878 154.017V172.025L86.0947 172.28L85.8016 172.06V154.017Z"
          fill="#383942"
        />
        <path
          d="M86.3878 62.9532L86.0947 62.7791L85.8016 62.9532V45.5255L86.0947 45.3513L86.3878 45.5255V62.9532Z"
          fill="#383942"
        />
      </g>
      <g clipPath="url(#clip1_1_67)">
        <path
          d="M221.844 58.4775L222.606 54.2628H243.426C244.95 54.2628 245.583 53.9958 245.782 52.8811L246.38 49.5605C246.38 49.456 246.415 49.3283 246.415 49.2354C246.415 48.4458 245.818 48.144 244.481 48.144H230.483C225.7 48.144 223.801 46.4256 223.801 43.7319C223.801 43.372 223.872 42.9424 223.93 42.5128L224.2 40.9337C224.763 37.5782 227.33 35.3025 232.781 35.3025H253.027L252.3 39.4824H232.054C230.624 39.4824 229.827 39.8423 229.628 40.8989L229.335 42.5476C229.3 42.6405 229.3 42.7798 229.3 42.8727C229.3 43.6274 229.897 43.9641 231.257 43.9641H245.255C250.038 43.9641 251.937 45.7057 251.937 48.3762C251.937 48.7709 251.902 49.1657 251.843 49.5953L251.245 52.8231C250.612 56.1786 248.15 58.4891 242.664 58.4891H221.844V58.4775Z"
          fill="white"
        />
        <path
          d="M264.317 58.4776C259.557 58.4776 257.67 56.7361 257.67 54.1004C257.67 53.7057 257.74 53.3109 257.799 52.8813L259.932 40.8874C260.53 37.5551 262.992 35.291 268.444 35.291H284.305C289.065 35.291 290.929 37.0326 290.929 39.6683C290.929 40.063 290.893 40.4578 290.835 40.8874L288.701 52.8813C288.103 56.2136 285.642 58.4776 280.19 58.4776H264.317ZM285.43 40.8293C285.43 39.9121 284.997 39.4825 283.566 39.4825H267.705C266.345 39.4825 265.548 39.9121 265.372 40.8293L263.215 52.9161C263.18 53.009 263.18 53.1135 263.18 53.1832C263.18 53.9379 263.848 54.2746 265.079 54.2746H280.94C282.3 54.2746 283.098 53.8798 283.273 52.9277L285.43 40.8293Z"
          fill="white"
        />
        <path
          d="M302.03 49.2936L300.401 58.4776H294.985L299.111 35.291H323.789L323.062 39.4709H303.812L302.816 45.1021H320.705L319.943 49.282H302.03V49.2936Z"
          fill="white"
        />
        <path
          d="M337.013 58.4776L340.401 39.4709H328.326L329.053 35.291H358.384L357.657 39.4709H345.852L342.464 58.4776H337.013Z"
          fill="white"
        />
        <path
          d="M388.758 58.4776L383.975 41.9091L373.002 58.4776H369.04L362.287 35.291H367.375L372.1 51.8595L382.944 35.291H387L391.783 51.8595L402.521 35.291H407.914L392.85 58.4776H388.758Z"
          fill="white"
        />
        <path
          d="M430.071 58.4776L421.889 40.8293L407.152 58.4776H400.998L420.716 35.291H424.702L436.074 58.4776H430.071Z"
          fill="white"
        />
        <path
          d="M463.318 58.4776L459.93 48.1673H448.629L446.8 58.4776H441.384L445.511 35.291H465.862C470.622 35.291 472.509 37.0326 472.509 39.7031C472.509 40.063 472.474 40.4578 472.415 40.8874L472.111 42.5709C471.618 45.3343 469.918 47.5403 465.628 48.0977L469.016 58.4776H463.318ZM466.976 40.8293C466.976 39.9121 466.542 39.4825 465.112 39.4825H450.176L449.379 43.9991H464.315C465.745 43.9991 466.448 43.732 466.648 42.6174L466.976 40.8293Z"
          fill="white"
        />
        <path
          d="M475.932 58.4776L480.059 35.291H504.736L504.009 39.4709H484.76L483.928 44.1152H502.145L501.383 48.3299H483.166L482.134 54.2629H501.383L500.621 58.4776H475.932Z"
          fill="white"
        />
        <path
          d="M221.539 98.012L225.665 74.8254H247.646C253.367 74.8254 255.466 76.4741 255.466 79.7368C255.466 80.3289 255.395 80.9907 255.266 81.6758L253.543 91.3939C252.781 95.7364 250.319 98.012 243.531 98.012H221.539ZM249.815 81.6758C249.885 81.2462 249.944 80.8862 249.944 80.5844C249.944 79.2723 249.112 79.0053 246.919 79.0053H230.354L227.728 93.7974H244.293C246.99 93.7974 247.752 93.4026 248.115 91.3243L249.815 81.6758Z"
          fill="white"
        />
        <path
          d="M259.627 98.012L263.754 74.8254H288.431L287.704 79.0053H268.455L267.622 83.6496H285.84L285.078 87.8643H266.86L265.829 93.7974H285.078L284.316 98.012H259.627Z"
          fill="white"
        />
        <path
          d="M298.197 88.8168L296.567 98.0009H291.151L295.278 74.8142H319.955L319.228 78.9941H299.979L298.982 84.6253H316.872L316.11 88.8051H298.197V88.8168Z"
          fill="white"
        />
        <path
          d="M321.479 98.012L325.605 74.8254H331.021L326.895 98.012H321.479Z"
          fill="white"
        />
        <path
          d="M363.612 98.012L342.299 80.7933L339.24 98.012H334.515L338.642 74.8254H343.331L362.756 90.9644L365.652 74.8254H370.412L366.285 98.012H363.612Z"
          fill="white"
        />
        <path
          d="M373.694 98.012L377.82 74.8254H402.498L401.771 79.0053H382.521L381.689 83.6496H399.907L399.145 87.8643H380.927L379.895 93.7974H399.145L398.383 98.012H373.694Z"
          fill="white"
        />
        <path
          d="M405.23 98.012L409.356 74.8254H431.337C437.058 74.8254 439.157 76.4741 439.157 79.7368C439.157 80.3289 439.087 80.9907 438.958 81.6758L437.234 91.3939C436.472 95.7364 434.01 98.012 427.223 98.012H405.23ZM433.495 81.6758C433.565 81.2462 433.624 80.8862 433.624 80.5844C433.624 79.2723 432.791 79.0053 430.599 79.0053H414.034L411.408 93.7974H427.973C430.669 93.7974 431.431 93.4026 431.795 91.3243L433.495 81.6758Z"
          fill="white"
        />
        <path
          d="M248.443 137.535L240.26 119.886L225.524 137.535H219.37L239.088 114.348H243.074L254.445 137.535H248.443Z"
          fill="white"
        />
        <path
          d="M287.189 114.348H292.605L289.475 131.938C288.877 135.27 286.415 137.535 280.964 137.535H266.028C261.269 137.535 259.381 135.793 259.381 133.157C259.381 132.763 259.452 132.368 259.51 131.938L262.64 114.348H268.057L264.926 131.973C264.891 132.066 264.891 132.17 264.891 132.24C264.891 132.995 265.56 133.331 266.79 133.331H281.726C283.086 133.331 283.883 132.937 284.059 131.985L287.189 114.348Z"
          fill="white"
        />
        <path
          d="M306.485 137.535L309.873 118.528H297.798L298.525 114.348H327.857L327.13 118.528H315.325L311.937 137.535H306.485Z"
          fill="white"
        />
        <path
          d="M336.215 137.535C331.456 137.535 329.568 135.793 329.568 133.157C329.568 132.763 329.638 132.368 329.697 131.938L331.831 119.944C332.429 116.612 334.89 114.348 340.342 114.348H356.203C360.963 114.348 362.827 116.089 362.827 118.725C362.827 119.12 362.792 119.515 362.733 119.944L360.599 131.938C360.002 135.27 357.54 137.535 352.088 137.535H336.215ZM357.329 119.886C357.329 118.969 356.895 118.539 355.465 118.539H339.603C338.243 118.539 337.446 118.969 337.27 119.886L335.113 131.973C335.078 132.066 335.078 132.17 335.078 132.24C335.078 132.995 335.746 133.331 336.977 133.331H352.839C354.199 133.331 354.996 132.937 355.172 131.985L357.329 119.886Z"
          fill="white"
        />
        <path
          d="M398.372 137.535L400.962 122.917L387.399 137.535H382.944L374.491 122.94L371.901 137.535H366.883L371.01 114.348H375.863L386.133 132.298L402.697 114.348H407.516L403.389 137.535H398.372Z"
          fill="white"
        />
        <path
          d="M437.75 137.535L429.567 119.886L414.831 137.535H408.677L428.395 114.348H432.381L443.752 137.535H437.75Z"
          fill="white"
        />
        <path
          d="M453.846 137.535L457.234 118.528H445.159L445.886 114.348H475.217L474.49 118.528H462.685L459.297 137.535H453.846Z"
          fill="white"
        />
        <path
          d="M477.327 137.535L481.454 114.348H486.87L482.744 137.535H477.327Z"
          fill="white"
        />
        <path
          d="M497.714 137.535C492.954 137.535 491.067 135.793 491.067 133.157C491.067 132.763 491.137 132.368 491.196 131.938L493.329 119.944C493.927 116.612 496.389 114.348 501.841 114.348H517.702C522.462 114.348 524.326 116.089 524.326 118.725C524.326 119.12 524.29 119.515 524.232 119.944L522.098 131.938C521.5 135.27 519.039 137.535 513.587 137.535H497.714ZM518.827 119.886C518.827 118.969 518.394 118.539 516.964 118.539H501.102C499.742 118.539 498.945 118.969 498.769 119.886L496.612 131.973C496.577 132.066 496.577 132.17 496.577 132.24C496.577 132.995 497.245 133.331 498.476 133.331H514.337C515.697 133.331 516.495 132.937 516.67 131.985L518.827 119.886Z"
          fill="white"
        />
        <path
          d="M557.479 137.535L536.166 120.304L533.106 137.535H528.382L532.508 114.348H537.197L556.623 130.487L559.518 114.348H564.278L560.151 137.535H557.479Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_67">
          <rect width="171" height="173" fill="white" />
        </clipPath>
        <clipPath id="clip1_1_67">
          <rect
            width="346"
            height="103"
            fill="white"
            transform="translate(219 35)"
          />
        </clipPath>
      </defs>
    </BaseIcon>
  );
};

LogoFullDark.displayName = 'LogoFullDark';
